import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Utility function to merge Tailwind classes
 */
const cn = (...inputs: (string | undefined | null | false)[]) => twMerge(clsx(inputs));

/**
 * Progress bar sizes
 */
export type ProgressSize = 'sm' | 'md' | 'lg';

/**
 * Progress bar variants
 */
export type ProgressVariant = 'default' | 'gradient' | 'striped';

/**
 * Size configurations for Progress
 */
export const progressSizeStyles: Record<ProgressSize, { track: string; label: string }> = {
  sm: {
    track: 'h-1.5 rounded-full',
    label: 'text-xs',
  },
  md: {
    track: 'h-2.5 rounded-full',
    label: 'text-sm',
  },
  lg: {
    track: 'h-4 rounded-full',
    label: 'text-base',
  },
};

/**
 * Klassen des Fortschrittsbalkens je Variante.
 *
 * Die Standardvariante bleibt bewusst leer: Sie wird ueber die Prop `color`
 * als Inline-Hintergrundfarbe gefaerbt, nicht ueber eine Klasse.
 */
export const getProgressBarClass = (variant: ProgressVariant, animated: boolean): string => {
  switch (variant) {
    case 'gradient':
      return 'bg-gradient-to-r from-primary via-chart-7 to-chart-5';
    case 'striped':
      return cn(
        'bg-primary',
        'bg-[length:1rem_1rem]',
        'bg-[linear-gradient(45deg,rgba(255,255,255,0.15)25%,transparent_25%,transparent_50%,rgba(255,255,255,0.15)50%,rgba(255,255,255,0.15)75%,transparent_75%,transparent)]',
        animated && 'animate-[progress-stripes_1s_linear_infinite]'
      );
    default:
      return '';
  }
};

/**
 * Begrenzt den Fortschritt auf 0..100 Prozent.
 */
export const toPercentage = (value: number, max: number): number =>
  Math.min(100, Math.max(0, (value / max) * 100));
